export default (to, from, next) => (router) => {
    if (!router.app.$auth.isAuthenticated()) {
        
        router.app.$cookie.set('returnUrl', to.fullPath, 7);
        
        next({name: 'unauthorized'});
    }
    next();
}